
require('prelude');

const window = require('window');

const _ = require('lodash');


function debugCallback () {
	_.extend(window, registry);
	return _.extend({}, registry);
}

const registry = debugCallback;

let debugNotificationShown = false;
const debugNotificationMessage = 'With great power comes great responsibility';

function exportDebugCallback () {
	try {
		Object.defineProperty(window, '_debug', {
			get: function () {
				if (!debugNotificationShown) {
					debugNotificationShown = true;
					try {
						registry.page.notifications.push(debugNotificationMessage);
					} catch (e) {
						console.info(debugNotificationMessage);
					}
				}

				return debugCallback;
			},
		});
	} catch (e) {
		console.warn(e);
		window._debug = debugCallback;
	}
}

module.exports = exportDebugCallback;

module.exports.set = _.partial(_.set, registry);
module.exports.extend = _.partial(_.extend, registry);

